// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".create-funnel-modal-container .textAreaMargin{\n margin-left: \"10px\";\n}", "",{"version":3,"sources":["webpack://./src/pages/Journeys/JourneysView/CreateFunnelModel.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;AACpB","sourcesContent":[".create-funnel-modal-container .textAreaMargin{\n margin-left: \"10px\";\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
